import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from '@/features/shared/lib/api';
import ResearcherCard from "@/features/researcher/components/ResearcherCard";

export default function JournalMajorAuthors({ journalId }) {
  const navigate = useNavigate();
  const [majorAuthors, setMajorAuthors] = useState([]);
  const [majorAuthorsLoading, setMajorAuthorsLoading] = useState(false);
  const [totalResults, setTotalResults] = useState(0);

  useEffect(() => {
    if (!journalId) return;
    let alive = true;

    async function run() {
      setMajorAuthorsLoading(true);
      try {
        const res = await get(`/rm/v1/journal/${encodeURIComponent(journalId)}/major_researcher`, {
          params: { size: 12 }
        });
        if (!alive) return;
        if (res?.status || res?.success) {
          const records = res?.result?.records || res?.records || [];
          const total = res?.result?.pageInfo?.totalResults || records.length;
          setMajorAuthors(records);
          setTotalResults(total);
        }
      } catch (e) {
        console.error('Failed to fetch major researchers:', e);
      } finally {
        if (alive) setMajorAuthorsLoading(false);
      }
    }

    run();
    return () => { alive = false; };
  }, [journalId]);

  if (!majorAuthorsLoading && majorAuthors.length === 0) {
    return null;
  }

  return (
    <div className="journal-print-hide mt-[60px] lg:mt-[80px]">
      <h2 className="text-[18px] font-bold mb-5 lg:text-[20px] lg:mb-6">
        Major Published Authors
      </h2>

      {majorAuthorsLoading && (
        <div className="flex justify-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      )}

      {!majorAuthorsLoading && majorAuthors.length > 0 && (
        <>
          <ul className="flex flex-wrap gap-4 2xl:gap-[28px]">
            {majorAuthors.map((author) => {
              const mappedItem = {
                ...author,
                id: author.scholar_id,
                scholar_name_eng: author.scholar_name_eng,
                scholar_name_kor: author.author_name,
                dept_name: author.dept_name,
                resource_count: author.count,
                profile_pic: author.profile_pic,
              };
              return (
                <ResearcherCard
                  key={author.scholar_id}
                  item={mappedItem}
                  yearDisplay="none"
                  liClassName="relative p-[18px] bg-white border border-[#E4E8F1] rounded-xl transition duration-300 w-[calc(50%-8px)] 2xl:w-[calc((100%-84px)/4)] hover:shadow-[0px_4px_20px_rgba(0,0,0,.05)] 2xl:p-[30px]"
                />
              );
            })}
          </ul>

          {totalResults > 12 && (
            <div className="mt-8 flex justify-center">
              <button
                type="button"
                onClick={() => navigate(`/researchers/?journal_id=${encodeURIComponent(journalId)}`)}
                className="inline-flex items-center justify-center gap-1 py-3 px-8 bg-[#F3F5F9] border border-[#E4E8F1] rounded-xl text-[14px] text-[#6C7687] font-medium hover:bg-[#EEF1F8] hover:border-[#E4E8F1] transition-colors cursor-pointer"
              >
                <span>More</span>
                <img
                  className="w-[16px]"
                  alt="link"
                  src={`${typeof rmVars !== 'undefined' ? rmVars.themeUrl : ''}images/launch-ico-6C7687.png`}
                />              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
